import { createApp } from "vue";
import App from "./App.vue";
import { VueClipboard } from "@soerenmartius/vue3-clipboard";
import store from "./store/store";
import router from "./router/router";

createApp(App)
	.use(store)
	.use(router)
	.use(VueClipboard)
	.mount("#app");

// console.log("main.js running...");
